// Engine / trim variants per make+model (e.g. BMW Série 3 → 320d, 330e, M340i).
// Curated for the most common brands; free-text is allowed for everything else.
const normKey = (s) => String(s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]/g, "");

const V = {
  BMW: {
    "Série 1": ["116i", "118i", "120i", "M135i", "116d", "118d", "120d"],
    "Série 2": ["218i", "220i", "M240i", "218d", "220d", "225e"],
    "Série 3": ["316i", "318i", "320i", "330i", "M340i", "318d", "320d", "320e", "330e", "330d", "M340d", "M3"],
    "Série 4": ["420i", "430i", "M440i", "420d", "430d", "M4"],
    "Série 5": ["520i", "530i", "540i", "M550i", "518d", "520d", "530d", "530e", "540d", "M5"],
    "Série 7": ["730i", "740i", "750i", "730d", "740d", "745e"],
    X1: ["sDrive18i", "xDrive20i", "sDrive18d", "xDrive20d", "xDrive23d", "xDrive25e"],
    X3: ["xDrive20i", "xDrive30i", "M40i", "xDrive20d", "xDrive30d", "M40d", "xDrive30e"],
    X5: ["xDrive40i", "M60i", "xDrive30d", "xDrive40d", "xDrive45e", "M"],
    i4: ["eDrive40", "M50"],
    iX: ["xDrive40", "xDrive50", "M60"],
  },
  Audi: {
    A1: ["25 TFSI", "30 TFSI", "35 TFSI", "40 TFSI"],
    A3: ["30 TFSI", "35 TFSI", "40 TFSI", "30 TDI", "35 TDI", "40 TDI", "40 TFSIe", "S3", "RS3"],
    A4: ["35 TFSI", "40 TFSI", "45 TFSI", "30 TDI", "35 TDI", "40 TDI", "S4", "RS4"],
    A6: ["40 TFSI", "45 TFSI", "55 TFSI", "40 TDI", "45 TDI", "50 TDI", "55 TFSIe", "S6", "RS6"],
    Q3: ["35 TFSI", "40 TFSI", "45 TFSIe", "35 TDI", "40 TDI", "RS Q3"],
    Q5: ["40 TDI", "45 TFSI", "50 TDI", "55 TFSIe", "SQ5"],
    Q7: ["45 TDI", "50 TDI", "55 TFSI", "SQ7"],
    "e-tron": ["50", "55", "S", "GT", "RS GT"],
  },
  "Mercedes-Benz": {
    "Classe A": ["A 160", "A 180", "A 200", "A 250", "A 180 d", "A 200 d", "A 220 d", "A 250 e", "A 35 AMG", "A 45 AMG"],
    "Classe B": ["B 180", "B 200", "B 180 d", "B 200 d", "B 250 e"],
    "Classe C": ["C 180", "C 200", "C 300", "C 200 d", "C 220 d", "C 300 d", "C 300 e", "C 43 AMG", "C 63 AMG"],
    "Classe E": ["E 200", "E 300", "E 200 d", "E 220 d", "E 300 d", "E 300 e", "E 53 AMG", "E 63 AMG"],
    GLA: ["GLA 200", "GLA 250", "GLA 200 d", "GLA 220 d", "GLA 250 e", "GLA 35 AMG"],
    GLC: ["GLC 200", "GLC 300", "GLC 220 d", "GLC 300 d", "GLC 300 e", "GLC 43 AMG"],
    "Classe V": ["V 220 d", "V 250 d", "V 300 d"],
  },
  Volkswagen: {
    Polo: ["1.0 TSI", "1.0 MPI", "GTI", "1.6 TDI"],
    Golf: ["1.0 TSI", "1.5 TSI", "1.5 eTSI", "2.0 TDI", "GTI", "GTD", "GTE", "R", "e-Golf"],
    Passat: ["1.5 TSI", "2.0 TSI", "2.0 TDI", "GTE"],
    Tiguan: ["1.5 TSI", "2.0 TSI", "2.0 TDI", "eHybrid", "R"],
    "T-Roc": ["1.0 TSI", "1.5 TSI", "2.0 TSI", "2.0 TDI", "R"],
    ID3: ["Pure", "Pro", "Pro S", "GTX"],
    ID4: ["Pure", "Pro", "GTX"],
  },
  Peugeot: {
    208: ["PureTech 75", "PureTech 100", "PureTech 130", "BlueHDi 100", "e-208", "GTi"],
    308: ["PureTech 110", "PureTech 130", "BlueHDi 130", "Hybrid 180", "Hybrid 225", "GT"],
    2008: ["PureTech 100", "PureTech 130", "BlueHDi 130", "e-2008"],
    3008: ["PureTech 130", "BlueHDi 130", "Hybrid 225", "Hybrid4 300"],
    5008: ["PureTech 130", "BlueHDi 130", "Hybrid"],
  },
  Renault: {
    Clio: ["SCe 65", "TCe 90", "TCe 140", "E-Tech", "dCi 100", "R.S."],
    Captur: ["TCe 90", "TCe 140", "E-Tech", "dCi 115"],
    Megane: ["TCe 140", "TCe 160", "E-Tech", "dCi 115", "R.S."],
    Austral: ["TCe 140", "TCe 160", "E-Tech 200"],
    Scenic: ["E-Tech 170", "E-Tech 220"],
  },
  Ford: {
    Fiesta: ["1.0 EcoBoost 100", "1.0 EcoBoost 125", "ST", "1.5 TDCi"],
    Focus: ["1.0 EcoBoost 125", "1.0 EcoBoost 155", "ST", "1.5 EcoBlue"],
    Puma: ["1.0 EcoBoost 125", "1.0 EcoBoost 155", "ST"],
    Kuga: ["1.5 EcoBoost", "2.0 EcoBlue", "PHEV", "FHEV"],
  },
  Toyota: {
    Yaris: ["1.0 VVT-i", "1.5 Hybrid", "GR"],
    Corolla: ["1.8 Hybrid", "2.0 Hybrid", "1.2 Turbo", "GR"],
    "C-HR": ["1.8 Hybrid", "2.0 Hybrid"],
    "RAV4": ["2.5 Hybrid", "2.5 Plug-in Hybrid"],
    "Yaris Cross": ["1.5 Hybrid"],
  },
  Opel: {
    Corsa: ["1.2", "1.2 Turbo", "1.5 Diesel", "Corsa-e", "GSe"],
    Astra: ["1.2 Turbo", "1.5 Diesel", "Hybrid", "Plug-in Hybrid", "GSe"],
    Mokka: ["1.2 Turbo", "1.5 Diesel", "Mokka-e"],
    Grandland: ["1.2 Turbo", "1.5 Diesel", "Hybrid", "Hybrid4"],
  },
  "Citroën": {
    C3: ["PureTech 83", "PureTech 110", "BlueHDi 100", "ë-C3"],
    C4: ["PureTech 130", "BlueHDi 130", "ë-C4"],
    "C5 Aircross": ["PureTech 130", "BlueHDi 130", "Hybrid 225"],
    "C5 X": ["PureTech 130", "Hybrid 225"],
  },
  Fiat: {
    500: ["1.0 Hybrid", "500e", "Abarth"],
    Panda: ["1.0 Hybrid", "1.2"],
    Tipo: ["1.0", "1.5 Hybrid", "1.6 Diesel"],
    "600": ["Hybrid", "600e"],
  },
  Skoda: {
    Fabia: ["1.0 MPI", "1.0 TSI", "1.5 TSI"],
    Octavia: ["1.0 TSI", "1.5 TSI", "2.0 TDI", "RS", "iV"],
    Superb: ["1.5 TSI", "2.0 TSI", "2.0 TDI", "iV"],
    Kodiaq: ["1.5 TSI", "2.0 TSI", "2.0 TDI", "RS"],
    Enyaq: ["60", "80", "85", "RS"],
  },
  SEAT: {
    Ibiza: ["1.0 MPI", "1.0 TSI", "1.5 TSI", "FR"],
    Leon: ["1.0 TSI", "1.5 TSI", "1.5 eTSI", "2.0 TDI", "e-Hybrid", "FR", "Cupra"],
    Arona: ["1.0 TSI", "1.5 TSI", "FR"],
    Ateca: ["1.0 TSI", "1.5 TSI", "2.0 TDI", "FR"],
  },
  Cupra: {
    Formentor: ["1.5 TSI", "2.0 TSI", "e-Hybrid", "VZ"],
    Leon: ["1.5 eTSI", "2.0 TSI", "e-Hybrid", "VZ"],
    Born: ["58 kWh", "77 kWh", "VZ"],
    Ateca: ["2.0 TSI VZ"],
  },
  Nissan: {
    Micra: ["IG-T 92", "IG-T 100"],
    Juke: ["DIG-T 114", "Hybrid"],
    Qashqai: ["Mild Hybrid 140", "Mild Hybrid 158", "e-Power"],
    "X-Trail": ["Mild Hybrid", "e-Power"],
    Leaf: ["40 kWh", "62 kWh e+"],
    Ariya: ["63 kWh", "87 kWh"],
  },
  Hyundai: {
    i10: ["1.0", "1.2", "N Line"],
    i20: ["1.0 T-GDi", "N Line", "N"],
    i30: ["1.0 T-GDi", "1.5 T-GDi", "1.6 CRDi", "N"],
    Kona: ["1.0 T-GDi", "1.6 Hybrid", "Kona Electric"],
    Tucson: ["1.6 T-GDi", "1.6 Hybrid", "1.6 Plug-in Hybrid", "1.6 CRDi"],
    Ioniq5: ["58 kWh", "77 kWh", "N"],
  },
  Kia: {
    Picanto: ["1.0", "1.2", "GT Line"],
    Rio: ["1.0 T-GDi", "1.2"],
    Ceed: ["1.0 T-GDi", "1.5 T-GDi", "1.6 CRDi", "GT"],
    Sportage: ["1.6 T-GDi", "1.6 Hybrid", "1.6 Plug-in Hybrid", "1.6 CRDi"],
    Niro: ["Hybrid", "Plug-in Hybrid", "EV"],
    EV6: ["58 kWh", "77 kWh", "GT"],
  },
  Volvo: {
    XC40: ["B3", "B4", "T4 Recharge", "Recharge Pure Electric"],
    XC60: ["B4", "B5", "T6 Recharge", "T8 Recharge"],
    XC90: ["B5", "B6", "T8 Recharge"],
    "V60": ["B3", "B4", "T6 Recharge"],
    EX30: ["Single Motor", "Twin Motor Performance"],
  },
  Tesla: {
    "Model 3": ["Standard Range", "Long Range", "Performance"],
    "Model Y": ["Standard Range", "Long Range", "Performance"],
    "Model S": ["Long Range", "Plaid"],
    "Model X": ["Long Range", "Plaid"],
  },
  MINI: {
    Cooper: ["Cooper", "Cooper S", "John Cooper Works", "Cooper SE"],
    Countryman: ["Cooper", "Cooper S", "Cooper SE ALL4", "John Cooper Works"],
    Clubman: ["Cooper", "Cooper S", "John Cooper Works"],
  },
  Dacia: {
    Sandero: ["SCe 65", "TCe 90", "TCe 100 ECO-G"],
    Duster: ["TCe 130", "TCe 150", "Blue dCi 115", "ECO-G 100"],
    Jogger: ["TCe 110", "Hybrid 140", "ECO-G 100"],
    Spring: ["45", "65"],
  },
  Mazda: {
    "Mazda2": ["1.5 Skyactiv-G", "Hybrid"],
    "Mazda3": ["2.0 e-Skyactiv-G", "2.0 e-Skyactiv-X"],
    "CX-30": ["2.0 e-Skyactiv-G", "2.0 e-Skyactiv-X"],
    "CX-5": ["2.0 Skyactiv-G", "2.2 Skyactiv-D"],
    "MX-30": ["e-Skyactiv", "R-EV"],
  },
  Porsche: {
    "911": ["Carrera", "Carrera S", "Carrera 4S", "Turbo", "Turbo S", "GT3"],
    Cayenne: ["V6", "S", "E-Hybrid", "GTS", "Turbo"],
    Macan: ["Macan", "T", "S", "GTS", "Electric"],
    Panamera: ["4", "4S", "E-Hybrid", "GTS", "Turbo"],
    Taycan: ["4S", "GTS", "Turbo", "Turbo S"],
  },
  "Land Rover": {
    "Range Rover Evoque": ["P200", "P250", "P300e", "D165", "D200"],
    "Range Rover Velar": ["P250", "P400e", "D200", "D300"],
    "Range Rover Sport": ["P400", "P510e", "D300", "D350"],
    Defender: ["P300", "P400", "D250", "D300"],
    Discovery: ["P360", "D250", "D300"],
  },
  "Alfa Romeo": {
    Giulia: ["2.0 Turbo", "2.2 Diesel", "Veloce", "Quadrifoglio"],
    Stelvio: ["2.0 Turbo", "2.2 Diesel", "Veloce", "Quadrifoglio"],
    Tonale: ["1.5 Hybrid", "1.3 Plug-in Hybrid Q4"],
  },
  Honda: {
    Jazz: ["1.5 i-MMD Hybrid", "1.5 i-MMD Crosstar"],
    Civic: ["1.5 VTEC Turbo", "2.0 e:HEV Hybrid", "Type R"],
    "HR-V": ["1.5 e:HEV Hybrid"],
    "CR-V": ["2.0 e:HEV Hybrid", "2.0 e:PHEV Plug-in"],
    "e:Ny1": ["Advance", "Elegance"],
  },
  Suzuki: {
    Swift: ["1.2 Dualjet Hybrid", "Sport"],
    Ignis: ["1.2 Dualjet Hybrid"],
    Vitara: ["1.4 Boosterjet Hybrid", "1.5 Full Hybrid AllGrip"],
    "S-Cross": ["1.4 Boosterjet Hybrid", "1.5 Full Hybrid AllGrip"],
    Across: ["2.5 Plug-in Hybrid"],
    Swace: ["1.8 Hybrid"],
  },
  Mitsubishi: {
    "Space Star": ["1.0", "1.2"],
    ASX: ["1.0 Turbo", "1.3 Turbo Hybrid", "1.6 Full Hybrid", "1.6 Plug-in Hybrid"],
    "Eclipse Cross": ["1.5 Turbo", "2.4 Plug-in Hybrid"],
    "Outlander": ["2.4 Plug-in Hybrid"],
    "Colt": ["1.0 Turbo", "1.6 Full Hybrid"],
  },
  Jeep: {
    Avenger: ["1.2 Turbo", "e-Avenger Electric"],
    Renegade: ["1.5 e-Hybrid", "1.3 4xe Plug-in"],
    Compass: ["1.5 e-Hybrid", "1.3 4xe Plug-in"],
    "Grand Cherokee": ["2.0 4xe Plug-in"],
    Wrangler: ["2.0 GME", "4xe Plug-in"],
  },
  Jaguar: {
    "E-Pace": ["P200", "P250", "P300e", "D165", "D200"],
    "F-Pace": ["P250", "P400e", "D200", "D300"],
    "XE": ["P250", "P300", "D200"],
    "XF": ["P250", "P300", "D200"],
    "I-Pace": ["EV400"],
  },
  Lexus: {
    "UX": ["250h", "300e"],
    "NX": ["350h", "450h+ Plug-in"],
    "RX": ["350h", "450h+ Plug-in", "500h"],
    "ES": ["300h"],
    "RZ": ["450e"],
  },
  Subaru: {
    Impreza: ["2.0i e-Boxer"],
    XV: ["1.6i", "2.0i e-Boxer"],
    Forester: ["2.0i e-Boxer"],
    Outback: ["2.5i"],
    Solterra: ["AWD"],
  },
  "DS": {
    "DS 3": ["PureTech 100", "PureTech 130", "BlueHDi 130", "E-Tense Electric"],
    "DS 4": ["PureTech 130", "BlueHDi 130", "E-Tense 225 Plug-in"],
    "DS 7": ["PureTech 130", "BlueHDi 130", "E-Tense 225", "E-Tense 300 4x4"],
    "DS 9": ["E-Tense 225", "E-Tense 250", "E-Tense 360 4x4"],
  },
  MG: {
    "MG3": ["Hybrid+"],
    "MG4": ["51 kWh", "64 kWh", "XPower"],
    "MG5": ["Long Range"],
    "ZS": ["1.0 T-GDI", "Hybrid+", "ZS EV"],
    "HS": ["1.5 T-GDI", "Plug-in Hybrid"],
    "Marvel R": ["Electric"],
  },
  BYD: {
    Dolphin: ["Active", "Boost", "Comfort", "Design"],
    Atto3: ["Comfort", "Design"],
    Seal: ["Design", "Excellence AWD"],
    "Seal U": ["Comfort", "Design DM-i"],
    Han: ["Excellence AWD"],
  },
  Polestar: {
    "Polestar 2": ["Standard Range Single Motor", "Long Range Single Motor", "Long Range Dual Motor"],
    "Polestar 3": ["Long Range Dual Motor", "Performance"],
    "Polestar 4": ["Long Range Single Motor", "Long Range Dual Motor"],
  },
  Smart: {
    "Fortwo": ["EQ", "Brabus"],
    "Forfour": ["EQ", "1.0", "0.9 Turbo"],
    "#1": ["Pro+", "Premium", "Brabus"],
    "#3": ["Pro+", "Premium", "Brabus"],
  },
  Abarth: {
    "595": ["Turismo", "Competizione"],
    "695": ["Turismo", "Competizione", "Esseesse"],
    "500e": ["Turismo", "Scorpionissima"],
  },
  Chevrolet: {
    Spark: ["1.0", "1.2"],
    Aveo: ["1.2", "1.4"],
    Cruze: ["1.4 Turbo", "1.6", "2.0 VCDi"],
    Captiva: ["2.2 VCDi", "2.4"],
    Camaro: ["2.0 Turbo", "3.6 V6", "6.2 V8 SS"],
    Corvette: ["Stingray", "Z06"],
  },
  Lancia: {
    Ypsilon: ["1.0 Hybrid", "1.2", "Ypsilon Elettrica"],
    Delta: ["1.4 T-Jet", "1.6 Multijet"],
  },
  Genesis: {
    G70: ["2.0T", "3.3T"],
    GV70: ["2.5T", "3.5T", "Electrified GV70"],
    GV80: ["2.5T", "3.0D", "3.5T"],
    G80: ["2.5T", "3.5T", "Electrified G80"],
    GV60: ["Premium", "Sport", "Sport Plus"],
  },
  Maserati: {
    Ghibli: ["GT", "Modena", "Trofeo"],
    Grecale: ["GT", "Modena", "Trofeo", "Folgore"],
    Levante: ["GT", "Modena", "Trofeo"],
    MC20: ["Coupé", "Cielo"],
  },
  SsangYong: {
    Tivoli: ["1.5 T-GDi", "1.6 Diesel"],
    Korando: ["1.5 T-GDi", "1.6 Diesel", "e-Motion"],
    Rexton: ["2.2 Diesel"],
    Torres: ["1.5 T-GDi", "EVX"],
  },
  Ferrari: {
    Roma: ["Coupé", "Spider"],
    "296": ["GTB", "GTS"],
    "SF90": ["Stradale", "Spider"],
    Purosangue: ["V12"],
    "812": ["Superfast", "GTS", "Competizione"],
    "F8": ["Tributo", "Spider"],
  },
  Lamborghini: {
    Huracán: ["EVO", "STO", "Tecnica", "Sterrato"],
    Urus: ["S", "Performante", "SE"],
    Revuelto: ["V12 Hybrid"],
    Aventador: ["S", "SVJ", "Ultimae"],
  },
  Bentley: {
    Continental: ["GT V8", "GT Speed", "GTC"],
    Bentayga: ["V8", "S", "EWB", "Hybrid"],
    "Flying Spur": ["V8", "Speed", "Hybrid"],
  },
  "Aston Martin": {
    Vantage: ["V8", "F1 Edition"],
    "DB12": ["V8"],
    DBX: ["V8", "707"],
    DBS: ["Superleggera", "770 Ultimate"],
  },
  "Rolls-Royce": {
    Ghost: ["V12", "Black Badge"],
    Cullinan: ["V12", "Black Badge"],
    Phantom: ["V12"],
    Spectre: ["Electric"],
  },
  McLaren: {
    "Artura": ["V6 Hybrid"],
    "720S": ["Coupé", "Spider"],
    "750S": ["Coupé", "Spider"],
    "GT": ["V8"],
  },
  Bugatti: {
    Chiron: ["Sport", "Super Sport", "Pur Sport"],
    Tourbillon: ["Hybrid V16"],
  },
  Lotus: {
    Emira: ["i4", "V6"],
    Eletre: ["S", "R"],
    Emeya: ["S", "R"],
  },
  Alpine: {
    "A110": ["A110", "GT", "S", "R"],
    "A290": ["GT", "GTS"],
  },
  Maybach: {
    "Classe S": ["S 580", "S 680"],
    GLS: ["600"],
  },
  Infiniti: {
    Q50: ["2.0t", "3.0t"],
    QX50: ["2.0t"],
    QX60: ["3.5"],
  },
  Acura: {
    Integra: ["Type S"],
    MDX: ["Type S"],
    "TLX": ["Type S"],
  },
  Isuzu: {
    "D-Max": ["1.9 TD", "3.0 TD"],
  },
  Cadillac: {
    Escalade: ["6.2 V8", "Sport"],
    "XT4": ["2.0T"],
    Lyriq: ["Electric"],
    "CT5": ["2.0T", "V"],
  },
  Dodge: {
    Charger: ["R/T", "Scat Pack", "SRT Hellcat"],
    Challenger: ["R/T", "Scat Pack", "SRT Hellcat"],
    Durango: ["R/T", "SRT"],
  },
  RAM: {
    "1500": ["Big Horn", "Laramie", "Rebel", "TRX", "Limited"],
    "2500": ["Laramie", "Power Wagon"],
  },
  Chrysler: {
    "300": ["V6", "V8 SRT"],
    Pacifica: ["V6", "Plug-in Hybrid"],
  },
  GMC: {
    Sierra: ["Elevation", "AT4", "Denali"],
    Yukon: ["SLT", "AT4", "Denali"],
    "Hummer EV": ["Edition 1", "3X", "2X"],
  },
  Buick: {
    Encore: ["1.2T", "1.4T"],
    Envision: ["2.0T"],
  },
  Lincoln: {
    Nautilus: ["2.0T", "2.7T"],
    Aviator: ["3.0T", "Grand Touring"],
    Navigator: ["3.5T"],
  },
  NIO: {
    ET5: ["75 kWh", "100 kWh"],
    ET7: ["75 kWh", "100 kWh"],
    EL6: ["75 kWh", "100 kWh"],
    EL7: ["75 kWh", "100 kWh"],
  },
  XPeng: {
    "P7": ["Long Range", "Performance"],
    "G6": ["Standard Range", "Long Range"],
    "G9": ["Long Range", "Performance"],
  },
  Lucid: {
    Air: ["Pure", "Touring", "Grand Touring", "Sapphire"],
    Gravity: ["Grand Touring"],
  },
  Rivian: {
    "R1T": ["Dual Motor", "Quad Motor"],
    "R1S": ["Dual Motor", "Quad Motor"],
  },
  Fisker: {
    Ocean: ["Sport", "Ultra", "Extreme"],
  },
  Leapmotor: {
    "T03": ["Electric"],
    "C10": ["Electric", "REEV"],
  },
  Zeekr: {
    "001": ["Long Range", "Performance"],
    "X": ["Long Range", "Performance"],
    "7X": ["Long Range", "Performance"],
  },
  Omoda: {
    "5": ["1.6 T-GDI", "E5 Electric"],
  },
  Jaecoo: {
    "7": ["1.6 T-GDI", "SHS Plug-in"],
  },
  Ora: {
    "03": ["Standard Range", "Long Range", "GT"],
    "07": ["Long Range", "Performance"],
  },
  VinFast: {
    "VF6": ["Eco", "Plus"],
    "VF8": ["Eco", "Plus"],
    "VF9": ["Eco", "Plus"],
  },
  Aiways: {
    "U5": ["Standard", "Prime"],
    "U6": ["Standard", "Prime"],
  },
  Chery: {
    Tiggo: ["Tiggo 4", "Tiggo 7 Pro", "Tiggo 8 Pro"],
    Omoda: ["Omoda 5"],
  },
  Haval: {
    Jolion: ["1.5T", "1.5 HEV"],
    "H6": ["2.0T", "1.5 HEV", "PHEV"],
  },
  Hongqi: {
    "E-HS9": ["Electric"],
    "H9": ["2.0T", "3.0T"],
  },
  Saab: {
    "9-3": ["1.8t", "2.0T", "TTiD"],
    "9-5": ["2.0T", "2.3T", "TiD"],
  },
  Daihatsu: {
    Terios: ["1.5"],
    Sirion: ["1.0", "1.3"],
    Materia: ["1.3", "1.5"],
  },
  Aixam: {
    City: ["Sans permis"],
    Coupé: ["GTI", "Premium"],
    Crossover: ["GTR", "Premium"],
  },
  Ligier: {
    "JS50": ["Sans permis"],
    "Myli": ["Electric"],
  },

};

// Normalized lookup so accents/case don't matter.
const IDX = {};
for (const [mk, models] of Object.entries(V)) {
  IDX[normKey(mk)] = {};
  for (const [md, list] of Object.entries(models)) IDX[normKey(mk)][normKey(md)] = list;
}

export function variantsFor(make, model) {
  if (!make || !model) return [];
  return (IDX[normKey(make)] || {})[normKey(model)] || [];
}


// Fuel-type inference from an engine/trim label (helps buyers scan at a glance).
export const FUEL_META = {
  electric: { label: "Électrique", short: "Élec.", dot: "bg-emerald-400", text: "text-emerald-300", ring: "ring-emerald-400/40" },
  phev: { label: "Hybride rechargeable", short: "Hybr. rech.", dot: "bg-cyan-400", text: "text-cyan-300", ring: "ring-cyan-400/40" },
  hybrid: { label: "Hybride", short: "Hybride", dot: "bg-sky-400", text: "text-sky-300", ring: "ring-sky-400/40" },
  diesel: { label: "Diesel", short: "Diesel", dot: "bg-amber-400", text: "text-amber-300", ring: "ring-amber-400/40" },
  petrol: { label: "Essence", short: "Essence", dot: "bg-slate-400", text: "text-slate-300", ring: "ring-slate-400/40" },
};

export function fuelOfVariant(v) {
  const s = String(v || "").toLowerCase();
  if (!s) return "petrol";
  // JLR plug-in codes (P300e/P400e/P510e) — before electric so they aren't read as EV
  if (/p\d{3}e/.test(s)) return "phev";
  // Bare X00e electric city cars (500e, 600e) — before the generic PHEV "###e" rule
  if (/\d00e\b/.test(s)) return "electric";
  // Pure electric
  if (/(kwh|electric|électr|elettr|e-?tron|eq[aesbc]|\bix\b|\bi[3457]\b|single motor|dual motor|twin motor|quad motor|\bev\b|\bgtx\b|folgore|e-?golf|ë|e-208|e-2008|e-?c[34]\b|mokka-e|corsa-e|spectre|taycan|lyriq|solterra|\bborn\b|enyaq|\bid\.?\s?[3457]\b|\bleaf\b|ariya|standard range|long range|\bperformance\b|e-motion|\bevx\b|pure electric)/.test(s)) return "electric";
  // Plug-in hybrid
  if (/(\d{2,3}\s?e\b|4xe|plug|phev|tfsie|hybrid4|e-?tense|\biv\b|\bgte\b|recharge)/.test(s)) return "phev";
  // Hybrid (full / mild)
  if (/(hybrid|hev|i-?mmd|e-?boxer|e-?power|\be-?tech\b|\beq\b|\bb[3-6]\b|etsi|\bmild\b|\bshs\b)/.test(s)) return "hybrid";
  // Diesel
  if (/(\b\d{2,3}\s?d\b|tdi|tdci|bluehdi|\bhdi\b|crdi|multijet|skyactiv-d|\bdci\b|ecoblue|diesel|\btd\b|vcdi|ttid|\btid\b|\bd\d{3}\b|\bgtd\b)/.test(s)) return "diesel";
  return "petrol";
}
